export default __webpack_public_path__ + "static/media/logo.e012a136.png";